function getWishlistPrice() {
  var priceElements = document.querySelectorAll(".wishlist-price");
  priceElements.forEach(function (priceElement) {
    var price = priceElement.getAttribute("data-price");
    // 3桁区切りにフォーマット
    price = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    priceElement.firstElementChild.innerHTML = "¥" + price + "(税込)";
  });
}


document.addEventListener("DOMContentLoaded", function (event) {
  var currentUrl = this.location.pathname;
  var observer = new MutationObserver(function () {
    /** DOMの変化が起こった時の処理 */
    getWishlistPrice();
  });

  if (currentUrl == "/apps/wishlist") {
    var wishListElement = document.querySelector(".wishlist-page");
    console.log(wishListElement);
    const config = {
      attributes: true,
      childList: true,
      characterData: true,
    };
    /** 要素の変化監視をスタート */
    observer.observe(wishListElement, config);
  }
});

function strIns(str, idx, val){
  var res = str.slice(0, idx) + val + str.slice(idx);
  return res;
};